export const inspiration = {
    create: '创建时间：',
    diy: '上传图片，根据AI灵感，DIY您的专属美图',
    toAI: '去AI',
    AICount: '您还可以优先出图{count}次,',
    upgradeMembership: '升级会员获得更多权限>',
    seniorMemberTip: '尊贵的{memberName}用户，您可享受无限次灵感使用',
    selectStyle: '选择空间风格',
    selectType: '选择空间类型',
    uploadLimit: '仅支持 jpg/png 图片，且不超过 10M',
    generate: '立即生成',
    AIDescriptionInfo: '这是AI改造后的',
    StyleDescriptionInfo: '风格的',
    switch: '切换',
    diff: '空间对比',
    origin: '原来的空间',
    resultSpace: '生成的空间',
    reGenerate: '重新生成',
    download: '下载生成的空间',
    newGenerate: '生成新空间',
    abreast: '并排',
    sameFrame: '比较',
    your: '您的灵感',
    uploadSpaceImg: '上传空间照片',
    uploadPictures: '上传图片',
    inspiration: 'AI灵感',
    supportImage: '仅支持jpg/png图片',
    maxFileSize: '图片不得超过10M',
    maxFileSize30: '图片不得超过30M',
    inverted: '按创建时间降序',
    sequence: '按创建时间升序',
    style: '空间风格',
    type: '空间类型',
    generatingPleaseWait: 'AI生成中，请稍后',
    generationFailed: '空间生成失败，请稍后再试...',
    loadMore: '正在加载更多',
    emptyText: '暂无AI灵感',
};
